import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  getCategory,
  updateCategory as updateCategoryService,
} from '../../services/categories';

const TabSetEditarCategoria = () => {
  const history = useHistory();

  const { categoryId } = useParams();

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const updateCategory = async event => {
    event.preventDefault();

    try {
      if (!title || !title.replace(/[!@#$%¨&()_+=~^<>|"]/g, '').trim()) {
        throw new Error('Informe um nome para a categoria!');
      }

      if (!description || !description.replace(/[!@#$%¨&()_+=~^<>|"]/g, '').trim()) {
        throw new Error('Informe uma descrição para a categoria!');
      }

      const newCategory = {
        title: title,
        description: description,
      };

      await updateCategoryService(categoryId, newCategory);

      toast.success('Categoria editada com sucesso!');

      history.push(`/categorias/listar-categorias`);
    } catch (e) {
      const errorMessage = e.response || e.message;
      toast.error('Erro ao editar categoria. ' + errorMessage);
    }
  };

  useEffect(() => {
    (async () => {
      const localCategory = await getCategory(categoryId);

      setTitle(localCategory.title);
      setDescription(localCategory.description);
    })();
  }, [categoryId]);

  return (
    <>
      <div className="tab-pane fade active show">
        <form
          onSubmit={e => updateCategory(e)}
          className="needs-validation"
          noValidate=""
        >
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group row">
                <label className="col-xl-2 col-md-4 d-flex justify-content-start">
                  <span>*</span> Título
                </label>
                <input
                  className="form-control col-md-7"
                  id="validationCustom0"
                  type="text"
                  required="required"
                  value={title}
                  onChange={e => setTitle(e.target.value)}
                />
              </div>
              <div className="form-group row">
                <label className="col-xl-2 col-md-4 d-flex justify-content-start">
                  <span>*</span> Descrição
                </label>
                <input
                  className="form-control col-md-7"
                  id="validationCustom1"
                  type="text"
                  required="required"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="pull-right">
            <button
              type="button"
              className="btn btn-secondary mr-2"
              onClick={() => {
                history.push(
                  `${process.env.PUBLIC_URL}/categorias/listar-categorias`,
                );
              }}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              Salvar
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default TabSetEditarCategoria;
